'use client';

import Link from 'next/link';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import { usePathname } from 'next/navigation';
import { TablerIconsProps } from '@tabler/icons-react';

interface Tag {
  label: string;
  className?: string;
  href: string;
  Icon: FunctionComponent<TablerIconsProps>;
}

export default function TagList({ tags }: { tags: Tag[] }) {
  const pathname = usePathname();

  return (
    <div className="flex flex-wrap justify-center gap-3">
      {tags?.map(({ label, className, href, Icon }) => (
        <Link
          key={label}
          href={href}
          data-active={pathname === href}
          className={clsx(
            'flex items-center gap-1.5 rounded border py-1.5 pe-3 ps-2.5 font-mono text-xs uppercase transition-colors',
            className,
          )}
        >
          <Icon size={16} stroke={1.5} />
          {label}
        </Link>
      ))}
    </div>
  );
}
